module.exports = __webpack_public_path__ + "img/avatar.0ba61a7d.png";